import { getMfeMountProps, isMfeMode } from '@/mfe/mfe-mode';
import {
  PublicClientApplication,
  InteractionRequiredAuthError,
  BrowserAuthError,
  LogLevel,
} from '@azure/msal-browser';
import {
  AZURE_API,
  AZURE_CLIENT_ID,
  AZURE_TENANT_ID,
  REDIRECT_URL,
} from '../env';

let msalInstance: PublicClientApplication | null = null;

const getMsalInstance = (
  clientId: string = AZURE_CLIENT_ID,
  tenantId: string = AZURE_TENANT_ID,
  redirectUri: string = REDIRECT_URL
) => {
  if (msalInstance) return msalInstance;

  const configuration = {
    auth: {
      clientId,
      authority: `https://login.microsoftonline.com/${tenantId}`,
      redirectUri,
    },
    cache: {
      cacheLocation: 'localStorage',
    },
    system: {
      loggerOptions: {
        loggerCallback: (
          level: number,
          message: string,
          containsPii: boolean
        ) => {
          if (containsPii) return;

          switch (level) {
            case LogLevel.Error:
              console.error(message);
              return;
            case LogLevel.Verbose:
              console.debug(message);
              return;
            case LogLevel.Warning:
              console.warn(message);
              return;
            default:
              break;
          }
        },
        piiLoggingEnabled: false,
      },
    },
  };

  msalInstance = new PublicClientApplication(configuration);
  return msalInstance;
};

const acquireAccessToken = async (
  clientId: string,
  tenantId: string,
  redirectUri: string,
  scope: string
) => {
  if (isMfeMode()) {
    return await getMfeMountProps().authToken([AZURE_API]);
  }

  const instance = getMsalInstance(clientId, tenantId, redirectUri);

  try {
    const accounts = instance.getAllAccounts();
    const activeAccount =
      instance.getActiveAccount() ||
      accounts.find((account) => account.tenantId === tenantId) ||
      accounts[0];

    const request = {
      account: activeAccount,
      scopes: [scope],
    };

    try {
      const res = await instance.acquireTokenSilent(request);
      return res.accessToken;
    } catch (error) {
      if (error instanceof InteractionRequiredAuthError)
        await instance.acquireTokenRedirect(request);
      else if (error instanceof BrowserAuthError)
        await instance.acquireTokenRedirect(request);
      else throw error;
    }
  } catch (error) {
    console.error('unknown error thrown during acquireAccessToken: ', error);
  }
};

export { getMsalInstance, acquireAccessToken };
